import './SelectControlLayout.css';

import { cnCanary } from '##/utils/bem';

export const cnSelectControlLayout = cnCanary('SelectControlLayout');
